module.exports = __webpack_public_path__ + "icon_container_40x40.svg";